import React from "react";
import { useTranslation } from "react-i18next";
import { SettingsLayout } from "@features/settings/components/SettingsLayout";
import { NotificationsForm } from "@features/settings/SettingsNotifications/NotificationsForm";
import { useUserProfile } from "@rentablo/api/apiv1";

type Props = {};

export const SettingsNotificationsPage = (props: Props) => {
  const { t } = useTranslation();
  const { data: userProfile } = useUserProfile();

  return (
    <SettingsLayout
      title={t("settings.notifications.title")}
      subtitle={t("settings.notifications.subtitle")}
      breadcrumbs={[
        { text: t("settings.sidebar.title") },
        { text: t("settings.sidebar.common.notifications") },
      ]}
    >
      {userProfile ? <NotificationsForm userProfile={userProfile} /> : null}
    </SettingsLayout>
  );
};
